











































































import { Input } from './mixins';
import { ValidationProvider } from 'vee-validate';
import { Component, Vue, Prop, Mixins, Emit } from 'vue-property-decorator';

@Component({
  components: {
    ValidationProvider,
  },
})
export default class FormBadgeSelect extends Mixins(Input) {
  @Prop({ default: false }) hideLabel?: boolean;

  @Prop({ default: () => [] }) options!: string[];

  @Prop({ default: '' }) readonly value!: string;

  @Prop({ default: 'bottom' }) readonly dir!: string;

  open: boolean = false;

  @Emit('input')
  onChange() {
    return this.localValue;
  }

  get hasLabelSlot() {
    return !!this.$slots.label;
  }
}
